import React from "react"
import { useState, useEffect } from "react"
import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"

const GlowBox = () => {
  const [Active, setActive] = useState(false)
  useEffect(() => {
    setTimeout(() => {
      setActive("active")
    }, 300)
  }, [])
  return (
    <Wrapper>
      <Glow>
        <div className={`${Active} glowLeft`}></div>
        <div className={`${Active} glowRight`}></div>
        <div className={`${Active} glowCenter`}></div>
      </Glow>
    </Wrapper>
  )
}

export default GlowBox

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -2;
  transition: 1s;

  @media (max-width: 480px) {
  }
`

const Glow = styled.div`
  width: 100%;
  height: 100%;
  cursor: none;
  position: relative;
  pointer-events: none;
  z-index: -1;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    backdrop-filter: blur(60px);
    z-index: -1;
    @media (max-width: 480px) {
      backdrop-filter: blur(100px);
    }
  }
  div {
    position: absolute;
    width: 40vw;
    height: 40vw;
    z-index: -1;
    border-radius: 40%;
    opacity: 0;
    transition: 1s;
    will-change: transform opacity;
    &.active {
      opacity: 0.1;
      @media (max-width: 768px) {
        opacity: 0.8;
      }
      &.glowLeft {
        top: 30vh;
        left: 0vw;
        background: linear-gradient(
          270deg,
          rgba(255, 255, 255, 0),
          ${themeGet("colors.primary")}
        );
        animation: animateGlowBox 5s 3s ease-in-out infinite;
        @media (max-width: 480px) {
          top: 0vh;
          animation: none;
        }
      }
      &.glowRight {
        top: 30vh;
        right: 0vw;
        background: linear-gradient(120deg, rgba(255, 255, 255, 0), #df66fa);
        animation: animateGlowBox 10s 3s ease infinite alternate;
        @media (max-width: 480px) {
          background: linear-gradient(
            120deg,
            rgba(255, 255, 255, 0),
            #df66fa80
          );
          top: 80vh;
          animation: none;
        }
      }
      &.glowCenter {
        top: -20vh;
        right: 30vw;
        background: linear-gradient(270deg, rgba(255, 255, 255, 0), #1267e0);
        animation: animateGlowBox 8s 3s ease infinite alternate;
        @media (max-width: 480px) {
          top: 30vh;
          animation: none;
        }
      }
    }
  }
  @keyframes animateGlowBox {
    0% {
      background-position: 0% 50%;
      transform: scale(0.75);
      opacity: 0.1;
    }
    50% {
      background-position: 100% 50%;
      transform: scale(1.5) translate(-20%, 0) rotate(90deg);
      opacity: 0.3;
    }
    100% {
      background-position: 0% 50%;
      transform: scale(0.75);
      opacity: 0.1;
    }
  }
`
